<template>
    <section class="section-padding">
        <div class="add-padding">
            <div class="row columns">
                <div class="col-md-5 col-sm-5">
                    <h2 class="titre-section mb-50">
                        <span class="span-background-blue">
                            EMCI et l’égalité des chances
                        </span>
                    </h2>
                    <div class="textDescription">
                        <p class="mb-20">
                            EMCI s’inscrit dans une politique d’égalité des chances afin de permettre à tous ses
                            apprenants
                            d’accéder à la prestation de bilan de compétences ou de formation de leur choix.
                        </p>
                        <div class="mb-20">
                            <p>Le cabinet s’engage à :</p>
                            <ul>
                                <li>Prendre en compte les besoins du bénéficiaire</li>
                                <li>Faire le lien entre les personnes concernées au sein du cabinet</li>
                                <li>Etudier les aménagements spécifiques pour accompagner le bénéficiaire de manière
                                    adaptée
                                </li>
                            </ul>
                        </div>
                        <p class="mb-20">
                            Dans ce but, nous nous appuyons sur une référente Handicap dont le rôle est d’orienter,
                            d’informer et de suivre les personnes en situation de handicap durant leur parcours.
                        </p>
                        <p class="mb-20">
                            <span class="fw-bold">Nous sommes à votre écoute !</span>
                        </p>
                        <div class="mb-20">
                            <a class="btn-transparent" href="/contactez-nous">Contactez-nous <i
                                    class="fa-solid fa-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-md-7 col-dm-7 padding-left-img">
                    <div class="d-flex imgSection h-75">
                        <div class="w-50 image-mobile ">
                            <img class="h-100" src="/images/valeur/valeur2.jpeg" alt="Valeur EMCI">
                        </div>
                        <div class="w-50 textSection d-flex flex-column justify-content-center gap-3 text-mobile ">
                            <i class="fa-solid fa-quote-left"></i>
                            <p>
                                Attentive au bon déroulement de votre démarche, je serai votre interlocutrice tout au
                                long
                                de votre parcours. Avec votre consultant ou formateur, nous mettrons tout en œuvre pour
                                que
                                votre accueil et votre accompagnement se déroule dans les meilleures conditions
                                possibles.
                            </p>
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="nameRef">Nathalie NOGUEIRA, Référente Handicap</span>
                                <i class="fa-solid fa-quote-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

</script>

<style scoped>
h2 span {
    white-space: nowrap;
}

.padding-left-img {
    padding: 50px 10px;
    margin-top: 40px;
}

.titre-section {
    text-align: left;
    font-size: 50px;
    font-family: Nunito;
    font-weight: 600;
}

ul {
    list-style-type: disc;
    margin: 0 2rem;
    padding: initial;
}

.textDescription p,
.textDescription li {
    font-family: Inter;
    font-size: 18px;
}

.btn-transparent {
    font-size: 20px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    letter-spacing: 0.8px;
    padding: 15px 25px;
}

.btn-transparent:hover {
    color: #fff;
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
}

.fa-quote-right,
.fa-quote-left {
    color: #83C1E8;
    font-size: 48px;
}

.imgSection {
    background: #fff;
    border-radius: 9px;
    box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.08);
}

.imgSection img {
    object-fit: cover;
    border-radius: 9px 0 0 9px;
}

.textSection {
    width: 60% !important;
    padding: 42px 24px;
}

.textSection p {
    color: #25233E;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
}

.nameRef {
    color: var(--tertiaire, #318EC7);
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 144%;
    letter-spacing: 0.72px;
}

.section-padding {
    padding: 5rem 0;
}

.w-50.image-mobile {
    width: 40% !important;
}

@media only screen and (min-width: 50px) and (max-width: 999px) {
    .image-mobile .h-100 {
        height: auto !important;
        width: auto !important;
        object-fit: contain;
    }
}


/* Styles pour les écrans de petite taille (S) */
@media screen and (max-width: 599px) {
    .imgSection {
        flex-direction: column;
        height: 100% !important;
    }

    .w-50 {
        width: unset !important;
    }

    h2 span {
        white-space: unset;
    }

    .w-50.image-mobile {
        width: unset !important;
    }

    .textSection {
        padding: 20px;
    }

    .padding-left-img {
        padding: 0px 10px;
        margin-top: 0px;
    }
}


/* Styles pour les écrans de taille moyenne (M) */
@media screen and (min-width: 600px) and (max-width: 768px) {
    .imgSection {
        flex-direction: column;
        height: 100% !important;
    }

    .w-50 {
        width: unset !important;
    }

    .w-50.image-mobile {
        width: 100% !important;
    }

}

@media screen and (min-width: 769px) and (max-width: 991px) {}

@media screen and (min-width: 1000px) and (max-width: 1024px) {
    .span-background-blue[data-v-2f62406f]::after {
        bottom: -8px;
        height: 17%;
    }
}

@media screen and (min-width: 1025px) and (max-width: 1087px) {}

@media screen and (min-width: 1088px) and (max-width: 1872px) {

    .textDescription p,
    .textDescription ul li,
    .textSection p {
        font-size: 14px;
        line-height: 144%;
    }

    .image-mobile {
        width: 60% !important;
    }

    .text-mobile {
        width: 80% !important;
    }

    .add-padding {
        padding: 0px 6.5vw;
    }

}

@media only screen and (min-width: 1450px) and (max-width: 1800px) {}
</style>